var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.$options.components.N8nText,{tag:"component",attrs:{"size":_vm.props.size,"color":_vm.props.color,"compact":true}},[_c(_vm.$options.components.FontAwesomeIcon,{tag:"component",class:_vm.$style[_vm.props.size],attrs:{"icon":_vm.props.icon,"spin":_vm.props.spin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }